// extracted by mini-css-extract-plugin
module.exports = {"transactionCard":"TransactionInfo_transactionCard__2H56G","transactionCardInfo":"TransactionInfo_transactionCardInfo__3q371","paymentHolder":"TransactionInfo_paymentHolder__2z17x"};